import {Injectable} from '@angular/core';
import {firstValueFrom, from} from 'rxjs';
import {map} from 'rxjs/operators';
import {PersonalizationService} from '@docma-mm-core/personalization/personalization.service';
import {MmViewService} from '../../mm-view.service';
import {Project} from '@docma-mm-core/project/project';

@Injectable()
export class LastUsedEntitiesService {

  constructor(private readonly personalizationService: PersonalizationService,
              private readonly mmViewService: MmViewService) {
  }

  async loadLastUsedEntities(personalizationKey: string, project?: Project, useJsonStringify = false) {
    if (!project) {
      project = await firstValueFrom(this.mmViewService.currentProject$);
    }

    return firstValueFrom(from(this.personalizationService.getProjectValue(project.MyDocmaUid, personalizationKey))
      .pipe(map(value => {
        if (value) {
          if (useJsonStringify) {
            const settingObj: { [index: number]: any } = JSON.parse(value);
            if (settingObj) {
              return settingObj;
            }
          }
          else {
            const settingObj: { [index: number]: any } = value;
            if (settingObj) {
              return settingObj;
            }
          }
        }
        return [];
      })));
  }

  async saveLastUsedEntities(entity: any, personalizationKey: string, lastUsedEntitiesCount = 5, useJsonStringify = false, filterOutDuplicatesByKey?: string) {
    const newSettingsObj: { [index: number]: any } = [];
    const currentProject = await firstValueFrom(this.mmViewService.currentProject$);
    const settingsObj = await this.loadLastUsedEntities(personalizationKey, currentProject);

    if (entity) {
      // Place the new entity at the start
      newSettingsObj[0] = entity;

      let newIndex = 1;
      for (let i = 0; i < lastUsedEntitiesCount; i++) {
          if (settingsObj && settingsObj.hasOwnProperty(i)) {
              // Skip the entity if it matches the new entity to avoid duplicates
              if (!filterOutDuplicatesByKey || (filterOutDuplicatesByKey && settingsObj[i][filterOutDuplicatesByKey] !== entity[filterOutDuplicatesByKey])) {
                  newSettingsObj[newIndex] = settingsObj[i];
                  newIndex++;
              }
          }

          if (newIndex >= lastUsedEntitiesCount) {
              break;
          }
      }
    }

    if (useJsonStringify) {
      await this.personalizationService.setProjectValue(currentProject.MyDocmaUid, personalizationKey, JSON.stringify(newSettingsObj));
    }
    else {
      await this.personalizationService.setProjectValue(currentProject.MyDocmaUid, personalizationKey, newSettingsObj);
    }
    return newSettingsObj;
  }


}
